<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'export-offers'">

  <p-breadcrumb class="max-w-full" [model]="breadcrumbItems" [home]="breadcrumbHomeItem"></p-breadcrumb>
  <div style="margin-top: 1em">
  <p-tabView ngClass="tabCustom">
    <p-tabPanel header="{{'ProgramTab.ProgramTabView' | translate}}">
      <div class="card">
        <div class="header-card">
          <h1 class="title-main">{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.PageTitle' | translate}}</h1>
        </div>
        <div class="body-card">

            <p class="subtitle">{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.PageDescriptionText' | translate}}</p>
            <div class="container-summary">
              <h3 class="title-summary">{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.CardTitle' | translate}} {{ monthName }} {{ year }}</h3>
            </div>

            <div class="grid gap-0 mb-4 mt-5">

              <div class="col-2 flex justify-content-start card-colors" >
                <div class="col-12 flex justify-content-start p-0 m-0">
                  <div class="grid card-summary border-50 total-amount-card">
                    <div class="col-12 md:col-12">
                      <p class="summary-title">{{'ImportCloseSaleDetail.TotalAmountSummary' | translate}}</p>
                    </div>
                    <div class="container-bottom-colors">
                        <div class="data-colors summary-card">
                          <span class="material-symbols-outlined icon-style">
                            monetization_on
                            </span>
                            <span class="summary-data">
                              {{totalPrice | currency: 'USD'}}
                            </span>
                        </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-2 flex justify-content-start card-colors">
                <div class="col-12 flex justify-content-start p-0 m-0">
                  <div class="grid card-summary border-50 total-boxes-card">
                    <div class="col-12 md:col-12">
                      <p class="summary-title">{{'ImportCloseSaleDetail.TotalBoxesSummary' | translate}}</p>
                    </div>
                    <div class="container-bottom-colors">
                      <div class="data-colors summary-card">
                          <span class="material-symbols-outlined icon-style">
                            inventory_2
                            </span>
                            <span class="summary-data">
                            {{totalBoxes | number:'1.0-0'}}
                            </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-2 flex justify-content-start card-colors">
                <div class="col-12 flex justify-content-start p-0 m-0">
                  <div class="grid card-summary border-50 total-pallets-card">
                    <div class="col-12 md:col-12">
                      <p class="summary-title">{{'ImportCloseSaleDetail.TotalPalletsSummary' | translate}}</p>
                    </div>
                    <div class="container-bottom-colors">
                      <div class="data-colors summary-card">
                          <span class="material-symbols-outlined icon-style">
                            pallet
                            </span>
                            <span class="summary-data">
                              {{totalPallets}}
                            </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-2 flex justify-content-start card-colors">
                <div class="col-12 flex justify-content-start p-0 m-0">
                  <div class="grid card-summary border-50 total-containers-card">
                    <div class="col-12 md:col-12">
                      <p class="summary-title">{{'ImportCloseSaleDetail.TotalContainers' | translate}}</p>
                    </div>
                    <div class="container-bottom-colors">
                      <div class="data-colors summary-card">
                        <span class="material-symbols-outlined icon-style">
                          package_2
                        </span>
                        <span class="summary-data">
                          {{totalContainers}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-2 flex justify-content-start card-colors">
                <div class="col-12 flex justify-content-start p-0 m-0">
                  <div class="grid card-summary border-50 total-exporters-card">
                    <div class="col-12 md:col-12">
                      <p class="summary-title">{{'ImportCloseSaleDetail.TotalExporters' | translate}}</p>
                    </div>
                    <div class="container-bottom-colors">
                      <div class="data-colors summary-card">
                          <span class="material-symbols-outlined icon-style">
                            person
                            </span>
                            <span class="summary-data">
                              {{totalExporters}}
                            </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="pd-b">

              <div style="padding-bottom:1em">
                <h2 style="padding-top:1em;margin:0">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.CalendarTitle' | translate}}</h2>
                <p style="padding:.5em 0; margin:0;">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.CalendarSubtitle' | translate}}.</p>
              </div>


              <div class="card-border-sm">
                <div class="container-months">

                  <div class="container-dropdown-sm">
                    <!--
                      <small class="label-select">{{'MyLoadFilter.YearLabel' | translate}}</small>
                    -->
                    <p-dropdown
                      [options]="yearsList"
                      [(ngModel)]="yearCalendar"
                      (onChange)="onYearChange($event)"
                      [style]="{'background-color': '#EDEFF2', 'padding':'0'}"
                      >
                    </p-dropdown>
                  </div>

                  <div class="divider"></div>
                  <div class="section-months">
                    <div *ngFor="let month of customMonths; let i = index"
                      class="chip-month"
                      (click)="handleMonths(month.name, month.id)"
                      [ngClass]="selectClassMonth(month.id)"
                      >{{getInitialLetters(month.name)}}</div>
                  </div>
                </div>
              </div>
            </div>


            <div class="grid">
              <div class="col-5">
                <p-calendar
                  #calendar
                  [inline]="true"
                  [showWeek]="true"
                  [firstDayOfWeek]="1"
                  [(ngModel)]="dateCalendar"
                  (onMonthChange)="onMonthChange($event)"
                  [readonlyInput]="true"
                  [style]="{'width':'100%','height':'300px'}"
                  >
                  <ng-template pTemplate="date" let-date>
                    <span *ngIf="getWeekNumber(date.day, date.month, date.year)" style="text-align: center;"  class="inWeekRange">
                      {{date.day}}
                    </span>
                    <span *ngIf="!getWeekNumber(date.day, date.month, date.year)" style="text-align: center;">
                      {{date.day}}
                    </span>
                </ng-template>
                </p-calendar>
              </div>
              <div class="col-7">


                <div class="card-border-sm" *ngIf="showChart">
                  <div class="title-chart">
                    {{monthNameSelected}} - {{yearCalendar}}
                  </div>
                  <div class="container-chart" >
                    <app-spline-area-chart [serie1]="seriesProgram" [serie2]="seriesLoad" [weeks]="weeksChart"></app-spline-area-chart>
                  </div>
                </div>
                <div *ngIf="!showChart" style="margin-left:.5em">
                  <h2 class="title-not-chart">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.TitleNotOrder' | translate}} {{monthNameSelected}}</h2>
                  <div class="divider"></div>
                  <p class="text-not-chart">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.TextNotOrder' | translate}}.</p>
                </div>

                <!--
                <h2>{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.FilterForText' | translate}}:</h2>
                <form [formGroup]="filterFormGroup">
                  <div class="grid p-fluid">
                    <div class="grid col-12 mt-2">
                      <div class="width-max col-5 input-importer-closed-sale-orders">
                        <label>{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.FilterFieldPerWeekLabel' | translate}}</label>
                        <p-inputNumber formControlName="week" placeholder="{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.FilterFieldPerWeekPlaceholder' | translate}}"/>
                      </div>
                      <div class="width-max col-5 flex align-items-end">
                        <p-button (click)="sidebarVisible = true" [style]="{'margin': '0px'}" style="width: 100%;"
                        label="{{'ImportCloseSaleDetail.FilterTextButton' | translate}}" class="p-inputtext-sm" styleClass="p-button-outlined">
                        <span class="material-symbols-outlined" style="margin-right: 6px;">
                          add
                          </span>
                        </p-button>
                      </div>
                    </div>
                    <div class="grid col-12 mt-2">
                      <div class="width-max col-5">
                        <p-button label="{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.CleanFilterButton' | translate}}" (onClick)="onClearFilter()" styleClass="p-button-outlined" style="width: 100%">
                        </p-button>
                      </div>
                      <div class="width-max col-5">
                        <p-button label="{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.ApplyFilterButton' | translate}}" (onClick)="onFilter()">
                        </p-button>
                      </div>
                    </div>
                  </div>
                </form>
                -->

              </div>
            </div>

          <div style="padding-top:1em">
            <h2 *ngIf="weekDtos.length > 0" style="padding-top:1em;margin:0">{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.WeekTitle' | translate}}</h2>
            <p *ngIf="weekDtos.length > 0" style="padding:.5em 0; margin:0">{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.WeekSubtitle' | translate}}.</p>


            <div class="searchbar-container" *ngIf="weekDtos.length > 0">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input type="text" pInputText placeholder="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.PlaceholderFilterProgram' | translate}}" class="full-width"  [(ngModel)]="searchTerm" (input)="filterLoads()" />
              </span>
            </div>

            <p-dataView [value]="filteredRegisters" [loading]="loading" [rows]="20" [paginator]="true" emptyMessage="{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.EmptyResultsText' | translate}}" filterBy="week">
              <ng-template let-dto pTemplate="listItem">
                <div class="col-12 mb-6">
                  <div class="flex justify-content-between align-items-center ">
                  <h3>{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.WeekFieldText' | translate}}: {{dto.week}} - {{dto.year}}</h3>
                    <div class="flex gap-1" *ngIf="dto.importOrdersDtos.length > 0" >
                      <p-button
                      (onClick)="onToggleDetail(dto)"
                      [icon]="!dto.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"
                      styleClass="p-button-outlined p-button-rounded p-button-text p-button-sm"
                      class="btn-toggle"
                      [ngClass]="{
                        'btn-expanded': dto.expanded,
                        'btn-collapsed': !dto.expanded
                      }">
                      </p-button>
                    </div>
                  </div>


                  <div class="week-import-orders-dataview"  *ngIf="dto.expanded">
                    <div class="list-scroll">
                      <p-dataView #dv
                      [value]="dto.importOrdersDtos"
                      [rows]="20"
                      [paginator]="false"
                      [loading]="loading"
                      emptyMessage="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.EmptyResultsText' | translate}}"
                      >
                        <ng-template pTemplate="header">
                        </ng-template>
                        <ng-template let-dto pTemplate="listItem">
                          <div class="card" [style]="{'margin-bottom': '20px'}">
                            <div class="container-row">
                              <div class="container-flex">
                                <div class="row-style border-lat">
                                  <!-- <img [src]="getImageUrl(dto.details[0].exportOffer)" style="border-radius: 7px; width: 100%; max-width: 100px; height: auto;" alt="" *ngIf="dto.details[0].exportOffer.offerPictures.length > 0"/>
                                  <span style="border-radius: 7px; padding: 5px; font-weight: bold;" *ngIf="dto.details[0].exportOffer.offerPictures.length < 1">{{'UserPages.UserExportOffers.NotAvailablePictureLabel' | translate}}</span> -->
                                  <div class="container-flex-fit">

                                    <div class="container-img">
                                      <!--
                                      -->
                                      <img loading="lazy" [src]="getIconUrl(dto.importOrder.directSaleProgram.exportOffer.variety.urlIcon) | speciesImageUrl" style="border-radius: 7px; width: 100%; max-width: 50px; height: auto;" alt="" *ngIf="dto.importOrder.directSaleProgram.exportOffer.variety.urlIcon"/>
                                      <span class="material-symbols-outlined" style="font-size:40px;opacity:.3;color:#8C2B87" *ngIf="!dto.importOrder.directSaleProgram.exportOffer.variety.urlIcon">
                                        no_photography
                                      </span>
                                    </div>
                                    <div class="flex-container container-main-info">
                                      <h2 class="text-main" style="font-size: 14px;">{{dto.details[0].exportOffer.variety.species | speciesName}}</h2>
                                    <!-- <span style="text-transform: uppercase; font-size: medium;">{{dto.details[0].exportOffer.variety.name}}</span> -->
                                      <span style="font-weight: normal; font-size: 12px;"><strong style="color: #8c2b87">{{'ImportCloseSaleTable.CodeText' | translate}}:</strong> {{dto.importOrder.sequence}}</span>
                                      <span style="font-weight: normal; font-size: 12px;"><strong style="color: #8c2b87">{{'ImportCloseSaleTable.InstructiveText' | translate}}:</strong> {{dto.delivery.deliveryInstructions}}</span>
                                      <span style="font-weight: normal; font-size: 12px;"><strong style="color: #8c2b87">{{'ImportCloseSaleTable.ContainerText' | translate}}:</strong> {{dto.delivery.containerNumber}}</span>
                                    </div>
                                  </div>
                                  <div class="flex align-items-center">
                                    <span class="material-symbols-outlined" style="color: #8c2b87">package_2</span>
                                    <span style="margin-left: 10px;" *ngIf="dto.details[0].palletPrices.length == 0">{{dto.details[0].palletsQuantity * dto.details[0].exportOffer.caseQuantityPerPallet}}</span>
                                    <span style="margin-left: 10px;" *ngIf="dto.details[0].palletPrices.length >= 1">{{ totalPalletPrice(dto.details[0].palletPrices)}}</span>
                                  </div>
                                  <div class="flex align-items-center">
                                    <p-button
                                    [style]="{'font-size': 'small','line-height':'1.1em','padding':'.5em .7em'}"
                                    label="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.SeeOrderButton' | translate}}"
                                    icon="pi pi-shopping-bag" (onClick)="goToOrderDetailPage(dto.importOrder.guid)"
                                    styleClass="p-button-outlined" class="btn-icon"
                                    >
                                    </p-button>
                                  </div>
                                </div>
                                <div class="row-style">
                                  <div class="col-12 md:col-8 flex justify-content-between align-items-center">
                                    <!-- <div class="flex justify-content-start align-items-center">
                                      <img [flag]="dto.importOrder.importFromCountry" height="40px" alt=""/>
                                      <div class="flex flex-column" style="margin-left: 10px;">
                                        <span style="font-weight: bolder; font-size: small;">{{dto.importOrder.importFromCountry.name}}</span>
                                      </div>

                                    </div> -->

                                    <app-location-info
                                    [type]="dto.importOrder.transportType"
                                    [countryName]="dto.importOrder.importFromCountry.name"
                                    [countryCode]="dto.importOrder.importFromCountry.code"
                                    >

                                    </app-location-info>
                                    <app-transport-type-icon
                                    [type]="dto.delivery.transportType"
                                    [ship]="dto.delivery?.ship"
                                    >
                                    </app-transport-type-icon>
                                    <!-- <div class="flex flex-column justify-content-center align-items-center">
                                      <div class="container-flex-fit">
                                        <span class="material-symbols-outlined" style="color: #6da043;">directions_boat</span>
                                        <span class="material-symbols-outlined" style="color: #6da043;">arrow_forward_ios</span>
                                      </div>
                                      <div *ngIf="dto.delivery?.ship" class="flex">
                                        <span class="text-center" style="font-size: small;">{{ dto.delivery?.ship }}</span>
                                      </div>
                                    </div> -->

                                    <!-- <div class="flex justify-content-start align-items-center">
                                      <img [flag]="dto.importOrder.importToCountry" height="40px" alt=""/>
                                      <div class="flex flex-column" style="margin-left: 10px;">
                                        <span style="font-weight: bolder; font-size: small; ">{{dto.importOrder.importToCountry.name}}</span>
                                      </div>
                                    </div> -->
                                    <app-location-info
                                    [type]="dto.importOrder.transportType"
                                    [countryName]="dto.importOrder.importToCountry.name"
                                    [countryCode]="dto.importOrder.importToCountry.code"
                                    >

                                    </app-location-info>

                                  </div>
                                  <div class="container-right-btns">
                                    <p-button
                                      icon="pi pi-shopping-bag"
                                      [style]="{'font-size': 'small', 'line-height':'1.1em','padding':'.5em .7em'}"
                                      label="{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.SeeExportOfferButton' | translate}}"
                                      (onClick)="viewExportOfferDetailDialog(dto.details[0])"
                                      styleClass="p-button-secondary p-button-outlined" class="btn-icon">
                                    </p-button>
                                    <div style="margin-left: 15px;" class="btn-expand-custom">
                                      <p-button
                                      [icon]="dto.importOrder.expanded ? 'pi pi-angle-up' : 'pi pi-angle-down'"
                                      styleClass="p-button-rounded p-button-outlined"
                                      (click)="setVisibleOrderDetail(dto.importOrder)"
                                      >
                                      </p-button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="container-flex">
                                <div  *ngIf="dto.importOrder.expanded" class="container-expanded">
                                  <div class="column-expanded-left">
                                    <div class="section-title">
                                      <span class="">{{'ImportCloseSaleTable.ProductDetailText' | translate}}</span>
                                    </div>

                                    <div class="flex">
                                      <div class="column-info-fit">


                                        <div class="row-info">
                                          <span class="material-symbols-outlined info-icon">
                                            location_on
                                            </span>
                                        <span class="info-text">
                                          {{'ImportCloseSaleTable.LocationText' | translate}}:
                                        </span>
                                          <span class="info-text" style="margin-left: 1px;">
                                            <app-text-preview-tooltip
                                              [text]="dto.details[0].fridgeStorage ?
                                              dto.details[0].fridgeStorage.contactCity + ',' +
                                              dto.details[0].fridgeStorage.contactAddress :
                                              'No included'"
                                              [maxWidth]="300"
                                              ></app-text-preview-tooltip>
                                          </span>
                                        </div>

                                        <div class="row-info">
                                          <span class="material-symbols-outlined info-icon">
                                            event
                                            </span>
                                            <span class="info-text">
                                              {{'ImportCloseSaleTable.ReadyToLoadDateText' | translate}}:
                                              {{dto.details[0].readyToLoadDate ? (dto.details[0].readyToLoadDate | date:'dd-MM-yyyy') : '-'}}
                                            </span>
                                        </div>

                                        <div class="row-info">
                                          <span class="material-symbols-outlined info-icon">
                                            calendar_today
                                            </span>
                                            <span class="info-text">
                                              {{'ImportCloseSaleTable.HarvestDateText' | translate}}:
                                              {{dto.details[0].harvestDate ? (dto.details[0].harvestDate | date:'dd-MM-yyyy') : '-'}}
                                            </span>
                                        </div>

                                        <div class="row-info">
                                          <span class="material-symbols-outlined info-icon">
                                            science
                                            </span>
                                            <span class="info-text" *ngIf="dto.details[0].exportOffer.isQualityControl">
                                              {{'UserPages.UserClosedSale.ProductDetail.QualityControlCriteriaText' | translate}}:
                                              {{'UserPages.UserClosedSale.ProductDetail.Included' | translate}}
                                            </span>
                                            <span class="info-text" *ngIf="!dto.details[0].exportOffer.isQualityControl">
                                              {{'UserPages.UserClosedSale.ProductDetail.QualityControlCriteriaText' | translate}}:
                                              {{'UserPages.UserClosedSale.ProductDetail.NotIncluded' | translate}}
                                            </span>
                                        </div>

                                        <div class="row-info">
                                            <span class="material-symbols-outlined info-icon" >
                                              monetization_on
                                              </span>
                                              <span class="info-text">
                                                {{'ImportCloseSaleTable.ListPriceText' | translate}}:
                                                <span *ngIf="dto.details[0].palletPrices.length == 1" class="info-text">
                                                {{dto.details[0].palletPrices[0].price | currency: 'USD':'US$'}}
                                              </span>
                                              <span class="info-text" *ngIf="dto.details[0].palletPrices.length == 0">
                                                {{'ImportCloseSaleTable.PriceNotEstablished' | translate}}
                                              </span>
                                              </span>
                                              <div *ngIf="dto.details[0].palletPrices.length > 1" class="see-prices" (click)="showCurrentPalletPriceModal(dto.details[0])">
                                                <span class="program-info-bold pl-2" style="color: #6da043;">
                                                  {{'ImportCloseSaleTable.SeePrices' | translate}}
                                                </span>
                                              </div>
                                              <!-- <p-button
                                              *ngIf="dto.details[0].palletPrices.length > 1"
                                              class="m-4"
                                              styleClass="p-button-sm"
                                              [style]="{'font-size': 'small'}"
                                              (onClick)="showCurrentPalletPriceModal(dto.details[0])"
                                              severity="secondary"
                                              icon="pi pi-eye"
                                              >
                                              </p-button>  -->
                                        </div>

                                      </div>
                                    </div>
                                  </div>

                                  <div class="flex-1"></div>

                                  <div class="column-expanded-left pl-3">
                                    <div class="section-title">
                                      <span style="opacity:0">.</span>
                                    </div>

                                    <div class="flex">
                                      <div class="column-info-fit">

                                        <div class="row-info">
                                          <span class="material-symbols-outlined info-icon" >
                                            pallet
                                            </span>
                                            <span class="info-text">
                                              {{'ImportCloseSaleTable.PalletText' | translate}}:
                                              {{dto.details[0].palletsQuantity}}
                                            </span>
                                        </div>

                                        <div class="row-info">
                                          <span class="material-symbols-outlined info-icon">
                                            heart_check
                                            </span>
                                            <span class="info-text">
                                              {{'ImportCloseSaleTable.ShelfLifeText' | translate}}:
                                              {{dto.details[0].shelfLife ? dto.details[0].shelfLife : '-'}}
                                            </span>
                                        </div>

                                        <div class="row-info">
                                          <span class="material-symbols-outlined info-icon">
                                            inventory_2
                                            </span>
                                            <span class="info-text"  *ngIf="dto.details[0].palletCaseConfig.length == 0">
                                              {{'ImportCloseSaleTable.CasePerPalletsText' | translate}}:
                                              {{dto.details[0].exportOffer.caseQuantityPerPallet}}
                                            </span>
                                            <span class="info-text"  *ngIf="dto.details[0].palletCaseConfig.length == 1">
                                              {{'ImportCloseSaleTable.CasePerPalletsText' | translate}}:
                                              {{dto.details[0].palletCaseConfig[0].boxesPerPallets }}
                                            </span>
                                            <div *ngIf="dto.details[0].palletCaseConfig.length > 1" class="see-prices" (click)="showCurrentCasesPerPallet(dto.details[0])">
                                              <span class="program-info-bold pl-2" style="color: #6da043;">
                                                {{'ImportCloseSaleTable.SeeCases' | translate}}
                                              </span>
                                            </div>
                                        </div>

                                        <div class="row-info">
                                          <span class="material-symbols-outlined info-icon" >
                                            weight
                                            </span>
                                            <span class="info-text">
                                              {{'UserPages.UserClosedSale.ProductDetail.NetKilosText' | translate}}:
                                              {{dto.details[0].exportOffer.netKilos ? dto.details[0].exportOffer.netKilos + ' kg' : '-' }}
                                            </span>
                                        </div>

                                      </div>
                                    </div>
                                  </div>

                                  <div class="flex-1"></div>


                                  <div class="" style="padding:0 1em;">
                                    <div class="">
                                      <div class="section-title">
                                        <span class="">{{'ImportCloseSaleTable.AgreementText' | translate}}</span>
                                      </div>
                                      <div class="flex flex-row align-items-center pb-2">
                                        <span class="material-symbols-outlined info-icon">
                                          person
                                          </span>
                                        <span class="info-text-program">
                                          {{'ImportCloseSaleTable.ExportadorText' | translate}}:
                                        </span>
                                        <span class="program-info">
                                          <!-- {{dto.details[0].directSalePrograms[0].importerCompanyName}} -->
                                          {{dto.details[0].exportOffer.exporter.companyName}}
                                        </span>
                                      </div>

                                      <div *ngIf="dto.importOrder.directSaleProgram?.consigneeCompanyName" class="flex flex-row align-items-center pb-2">
                                        <span class="material-symbols-outlined info-icon">
                                          person
                                          </span>
                                        <span class="info-text-program">
                                          Consignee:
                                        </span>
                                        <span class="program-info">
                                        <span class="program-info">
                                          <app-text-preview-tooltip
                                          [text]="dto.importOrder.directSaleProgram.consigneeCompanyName"
                                          [maxWidth]="200">
                                        </app-text-preview-tooltip>
                                          </span>
                                        </span>
                                      </div>

                                      <div *ngIf="dto.importOrder.directSaleProgram?.notifyCompanyName" class="flex flex-row align-items-center pb-2">
                                        <span class="material-symbols-outlined info-icon">
                                          person
                                          </span>
                                        <span class="info-text-program">
                                          Notify:
                                        </span>
                                        <span class="program-info">
                                          <app-text-preview-tooltip
                                          [text]="dto.importOrder.directSaleProgram.notifyCompanyName"
                                          [maxWidth]="200">
                                        </app-text-preview-tooltip>
                                        </span>
                                      </div>

                                      <div *ngIf="dto.importOrder.forwarderCompany?.companyName" class="flex flex-row align-items-center pb-2">
                                        <span class="material-symbols-outlined info-icon">
                                          person
                                          </span>
                                        <span class="info-text-program">
                                          Forwarder:
                                        </span>
                                        <span class="program-info">
                                          <app-text-preview-tooltip
                                          [text]="dto.importOrder.forwarderCompany.companyName"
                                          [maxWidth]="200">
                                        </app-text-preview-tooltip>
                                        </span>
                                      </div>

                                      <div *ngIf="dto.importOrder.customAgent?.companyName" class="flex flex-row align-items-center pb-2">
                                        <span class="material-symbols-outlined info-icon">
                                          person
                                          </span>
                                        <span class="info-text-program">
                                          Custom Agent:
                                        </span>
                                        <span class="program-info">
                                          <app-text-preview-tooltip
                                          [text]="dto.importOrder.customAgent.companyName"
                                          [maxWidth]="200">
                                        </app-text-preview-tooltip>
                                        </span>
                                      </div>

                                    </div>
                                  </div>

                                  <div class="flex-1"></div>

                                  <div class="week-column">
                                    <div class="section-title">
                                      <span class="">{{'ImportCloseSaleTable.Week/Year' | translate}}</span>
                                    </div>
                                    <div class="container-flex container-week">
                                      <div class="flex justify-content-start align-items-end">
                                        <span class="material-symbols-outlined info-icon">
                                          calendar_today
                                        </span>
                                          <span class="program-info-bold">{{dto.importOrder.closedSaleWeek}} - {{dto.importOrder.closedSaleWeekYear}}</span>
                                      </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                          </div>
                        </ng-template>
                      </p-dataView>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-dataView>
          </div>
        </div>

      </div>
    </p-tabPanel>
    </p-tabView>

  </div>

  </app-user-dashboard>



<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleExportOfferDialog" [style]="{width: '80%'}">
  <app-export-offer-detail [offer]="exportOffer" [productCertificateTypes]="selectedProductCertificateTypes" [packagingTypes]="selectedPackagingTypes"></app-export-offer-detail>
  <ng-template pTemplate="footer">
    <p-button label="{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.CloseButton' | translate}}" (click)="visibleExportOfferDialog = false"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.CurrentPricesHeader' | translate}}" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleCurrentPalletsPrice" [style]="{width: '800px'}">
  <p-table
  [value]="currentPrices"
  [paginator]="true"
  [rows]="10"
  [loading]="loading"
  responsiveLayout="stack"
  [breakpoint]="'600px'"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  >
  <ng-template pTemplate="header">
    <tr>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.CategoryHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesSizeHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.BoxQuantityHeader' | translate}}
      </th>
      <th  *ngIf="priceView">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.PriceHeader' | translate}}
      </th>
    </tr>
  </ng-template>
  <ng-template  pTemplate="body" let-palletPrice>
    <tr>
      <td>
        {{palletPrice.category}}
      </td>
      <td>
        {{palletPrice.speciesSize}}
      </td>
      <td>
        {{palletPrice.boxPerPallets}}
      </td>
      <td *ngIf="priceView">
        {{palletPrice.price | currency: 'USD'}}
      </td>
    </tr>
  </ng-template>
  </p-table>
</p-dialog>


<p-dialog header="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.BoxesPerPalletsHeader' | translate}}" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleCurrentPalletsCases" [style]="{width: '70vw'}">
  <p-table
  [value]="palletCases"
  [paginator]="true"
  [rows]="10"
  [loading]="loading"
  responsiveLayout="stack"
  [breakpoint]="'600px'"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  >
  <ng-template pTemplate="header">
    <tr>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesHeader' | translate}}
      </th>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.VarietyHeader' | translate}}
      </th>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesSizeHeader' | translate}}
      </th>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.PalletsHeader' | translate}}
      </th>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.BoxQuantityHeader' | translate}}
      </th>
    </tr>
  </ng-template>
  <ng-template  pTemplate="body" let-palletPrice>
    <tr>
      <td style="text-align: center;">
        {{palletPrice.speciesName}}
      </td>
      <td style="text-align: center;">
        {{palletPrice.varietyName}}
      </td>
      <td style="text-align: center;">
        {{palletPrice.speciesSize}}
      </td>
      <td style="text-align: center;">
        {{palletPrice.pallets}}
      </td>
      <td style="text-align: center;">
        {{palletPrice.boxesPerPallets}}
      </td>
    </tr>
  </ng-template>
      <ng-template pTemplate="footer">
    <tr>
      <td  style="text-align: center;">Total:</td>
      <td colspan="2" ></td>
      <td  style="text-align: center;">{{ getTotalPallets()  }}</td>
      <td  style="text-align: center;">{{ getTotalCases()  }}</td>
    </tr>
  </ng-template>
  </p-table>
</p-dialog>

<p-sidebar [(visible)]="sidebarVisible" position="right">
  <h3 style="text-align: center;">{{'AdvancedFilters.SideBarTitle' | translate}}</h3>

  <form [formGroup]="othersFiltersForm">
    <div class="col-12 flex justify-content-center flex-column">
      <div class="col-12 flex justify-content-center flex-column">
        <p-calendar
          inputId="harvestDate"
          formControlName="harvestDate"
          appendTo="body"
          [showButtonBar]="true"
          [showIcon]="true"
          [showWeek]="true"
          placeholder="{{'AdvancedFilters.HarvestDatePlaceholder' | translate}}"
          [firstDayOfWeek]="1"></p-calendar>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <input pInputText inputId="netKilos" formControlName="kilosPerBox"
        placeholder="{{'AdvancedFilters.KilosPerBoxFieldPlaceholder' | translate}}"/>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <p-dropdown
        [options]="countries"
        formControlName="marketId"
        optionLabel="name"
        optionValue="id"
        [filter]="true"
        filterBy="name"
        autoWidth="false" [style]="{'width':'100%'}"
        [showClear]="true"
        (onChange)="countryChange()"
        placeholder="{{'AdvancedFilters.MarketPlaceholder' | translate}}"
        class="p-inputtext-sm">
        <ng-template pTemplate="selectedItem">
          <div class="flex align-items-center gap-2" *ngIf="selectedCountryFrom">
            <img loading="lazy" [flag]="selectedCountryFrom.code" style="width: 18px" alt="flag"/>
            <div>{{ selectedCountryFrom | countryDescription }}</div>
          </div>
        </ng-template>
        <ng-template let-country pTemplate="item">
          <div class="flex align-items-center gap-2">
            <img loading="lazy" [flag]="country.code" style="width: 18px" alt="flag"/>
            <div>{{ country | countryDescription }}</div>
          </div>
        </ng-template>
      </p-dropdown>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <input pInputText formControlName="speciesSize" placeholder="{{'AdvancedFilters.SpeciesSizeFieldPlaceholder' | translate}}"/>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <input pInputText formControlName="shelfLife" placeholder="{{'AdvancedFilters.ShelfLife' | translate}}"/>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <input pInputText formControlName="price" placeholder="{{'AdvancedFilters.PricePlaceholder' | translate}}"/>
      </div>
        <div class="col-12 flex justify-content-center flex-columnr">
          <p-button label="{{'AdvancedFilters.ApplyFiltersText' | translate}}" styleClass="p-button" (onClick)="onFilter()">
            <span class="material-symbols-outlined">
              tune
              </span>
          </p-button>
        </div>
    </div>
  </form>
</p-sidebar>
